import Link from 'next/link';

import BlogPost from 'components/blog/blog-post/blog-post';
import Container from 'components/container/container';
import { LIBUM_URL } from 'shared/constants/globals';
import { BLOG_ITEMS } from 'shared/data/blogs';

const BLOG = BLOG_ITEMS.find((b) => b.id === 'new-year-new-site')!;

import SUN from 'public/icons/eva/sun.svg';
import MOON from 'public/icons/eva/moon.svg';
import { useTheme } from 'shared/styles/theme';

export default function NewYearNewSite() {
  const title = `${BLOG.title} | Libum`;
  const description = BLOG.description;
  const keywords = BLOG.keywords.join(',');
  const url = `${LIBUM_URL}/blog/${BLOG.id}`;
  const { theme, toggleTheme } = useTheme();

  return (
    <Container
      title={title}
      description={description}
      keywords={keywords}
      url={url}
      socialCard="blog"
      breadcrumbs={[
        { name: 'Blog', url: `${LIBUM_URL}/blog` },
        { name: BLOG.title, url },
      ]}
      blog={BLOG}
    >
      <div style={{ width: '100%' }}>
        <BlogPost blog={BLOG}>
          <p>Today we gave our website a much needed refresh.</p>
          <p>
            Basically, we needed to include the newest addition to our product line,{' '}
            <Link href="/poweron-pro">PowerOn Pro</Link> and at the same time, <Link href="/glaci">Glaci</Link> had
            recently undergone some pretty significant design changes — it just made sense.
          </p>
          <div className="divider" />
          <h2 className="anchor" id="what-has-changed">
            <Link href="#what-has-changed">What has changed</Link>
          </h2>
          <p>
            Other than the obvious design changes, we&apos;ve compiled a short list of things to look out for.
            Hopefully, you&apos;ll like them as much as we do!
          </p>
          <h3 className="anchor" id="products">
            <Link href="#products">Products</Link>
          </h3>
          <p>
            You&apos;ll now find a straight forward approach to each of our products giving you <b>(1)</b> what the
            inspiration was behind creating it <b>(2)</b> the list of capabilities it has and <b>(3)</b> which of those
            features are available by offering.
          </p>
          <p>
            Our imagination has run wild with the different things we know we can bring to the community so when I tell
            you we&apos;re just getting started, we&apos;re definitly not kidding around.
          </p>
          <p>
            If you haven&apos;t already, and feel like any of the following applies to you, definitely check out our
            answers to them.
          </p>
          <ul>
            <li>
              <Link href="/poweron-pro">PowerOn Pro</Link> — write any PowerOn ever and like a rich set of features
            </li>
            <li>
              <Link href="/nexum">NexumAPI</Link> — want to develop Symitar applications but SOAP is challenging or you
              just prefer to work in JSON with SymXchange
            </li>
            <li>
              <Link href="/glaci">Glaci</Link> — want to level up the UI and UX for your Symitar Quest users
            </li>
          </ul>
          <h3 className="anchor" id="theme">
            <Link href="#theme">Theme</Link>
          </h3>
          <p>
            We care about your eyes, so say goodbye to the unavoidable blinding white background and hellow to a clean
            theme switcher in the top right corner of every page.
          </p>
          <p>
            Toggle between the{' '}
            <span className="svg">
              <MOON
                className="theme-toggle"
                onClick={() => {
                  theme === 'light' && toggleTheme();
                }}
              />
            </span>{' '}
            and{' '}
            <span className="svg">
              <SUN
                className="theme-toggle"
                onClick={() => {
                  theme === 'dark' && toggleTheme();
                }}
              />
            </span>{' '}
            to choose what&apos;s right for you and your environment.
          </p>
          <h3 className="anchor" id="legal-docs">
            <Link href="#legal-docs">Legal Docs</Link>
          </h3>
          <p>
            Initially we offered our latest <Link href="/legal">Legal Docs</Link> as strictly as PDFs which would
            semi-render on mobile devices. Now, we have a the latest revisions available in inline-HTML to make it
            easier to read and navigate but also provide a download option to store local copies.
          </p>
          <div className="divider" />
          <h2 className="anchor" id="your-stuff-your-way">
            <Link href="#your-stuff-your-way">Your stuff, your way</Link>
          </h2>
          <p>
            For those of you that are currently using <Link href="/poweron-pro">PowerOn Pro</Link> and/or{' '}
            <Link href="/nexum">NexumAPI</Link>, we&apos;re getting ready to release your very own portal to manage your
            organization. This means, we&apos;ll effectively have a self-serve platform for you to manage your users,
            subscriptions, and configurations.
          </p>
          <p>
            We&apos;ll start first with <Link href="/poweron-pro">PowerOn Pro</Link> subscription management and then
            move on to <Link href="/nexum">NexumAPI</Link> configurations. We expect to start rolling this out this
            quarter.
          </p>
        </BlogPost>
      </div>
    </Container>
  );
}
